import { useDynamicFiltersStoreBuilder } from "@/shared/stores/dynamic-filters-builder.store";

export const useControlResultFiltersStore = useDynamicFiltersStoreBuilder();
